<template>
	<transition name="show">
		<div class="editpet" v-show="showflag">
      <header-top :isshow="true" @back="back"></header-top>
        <div class="main" ref='wrapper'>
				<div style="height:600px;">
				<div class="title">
				<div class="head_img">
					<img :src="imgflag?avatar:avatar1" @click.stop="uploadHeadImg" style="margin: auto;display: block;" v-show="isshow"/>
          <canvas ref="can" v-show="showflag1" style="width:80px;height:80px;margin: auto;display: block;border-radius: 50%;" @click.stop="uploadHeadImg"></canvas>
				</div>
				<input type="file" accept="image/*" @change="handleFile" class="hiddenInput" />
			</div>
					<div class="petmessage">
            <div class="pet-msg">
						<div class="petname">
							<span>{{$t('addpet.petName')}}</span>
							<el-input :value='petname' @input='changename' @change="Verificationname" maxlength="12"></el-input>
              <span class="danger" v-show='flag2'>{{$t('addpet.flag2')}}</span>
              <span class="danger" v-show='flag6'>{{$t('addpet.have')}}</span>
						</div>
            		<div class="petbelong">
								<span>{{$t('addpet.petType')}}</span>
								<el-input :value='petbelong' @input='changepetbelong' @change="Verificationbelong" maxlength="8"></el-input>
                <span class="danger" v-show='flag3'>{{$t('addpet.enterchinese')}}</span>
                <span class="danger" v-show='flag7'>{{$t('addpet.have')}}</span>
							</div>
            </div>
						<div class="pet-msg">
							<div class="haircolor">
								<span>{{$t('addpet.color')}}</span>
								<el-input :value='haircolor' @input='changehaircolor' @change="Verificationhaircolor" maxlength="6"></el-input>
                <span class="danger" v-show='flag4'>{{$t('addpet.enterchinese')}}</span>
                <span class="danger" v-show='flag8'>{{$t('addpet.have')}}</span>
							</div>
							<div class="sex">
								<span>{{$t('addpet.sex')}}</span>
								<div class="selectsex">
							  <el-select v-model="value" :placeholder="$t('addpet.selectSex')">
                <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
                </el-option>
             </el-select>
								</div>
							</div>
						</div>
						<div class="pet-msg">
							<div class="weight">
								<span>{{$t('addpet.weight')}}(KG)</span>
								<el-input :value='weight' @input='changeweight' @change='judgeweight'  :maxlength="maxweight" type="number"></el-input>
								<br />
								<span class="danger" v-show='flag1'>{{$t('addpet.not')}}</span>
                <span class="danger" v-show='flag9'>{{$t('addpet.have')}}</span>
							</div>
              <div class="height">
								<span>{{$t('addpet.height')}}(CM)</span>
								<el-input :value='height' @input='changeheight' @change='judgeheight' :maxlength="maxheight" type="number"></el-input>
								<br />
								<span class="danger" v-show='flag'>{{$t('addpet.not')}}</span>
                <span class="danger" v-show='flag10'>{{$t('addpet.have')}}</span>
							</div>
						</div>
						<div class="pet-msg">
							<div class="birthday">
								<span>{{$t('addpet.birthday')}}</span>
								<div class="block">
									<el-date-picker type="date" value-format="yyyy-MM-dd" v-model='birthday' :picker-options="pickerOptions" @focus='disapper' ref='datetime'>
									</el-date-picker>
								</div>
							</div>
						<div class="character">
							<span>{{$t('addpet.character')}}</span>
							<el-input :value='character' @input='changecharacter' @change="Verificationcharacter" maxlength="8"></el-input>
              <span class="danger" v-show='flag5'>{{$t('addpet.enterchinese')}}</span>
              <span class="danger" v-show='flag11'>{{$t('addpet.have')}}</span>
						</div>
						</div>
					</div>
					<div>
						<div class="save-btn" style="margin: 20px 0;">
							<el-button type="primary" style='margin: auto;display: block;width: 80%;' @click='save'>{{$t('addpet.savechage')}}</el-button>
						</div>
					</div>
				</div>
			</div>
		</div>
    	</transition>
</template>
<script>
import IScroll from "iscroll/build/iscroll-probe";
import headerTop from "../../components/header";
import {
  getpet,
  updatePet
} from "../../ClientServerApi/index.js";
import store from "../../store/store.js";
import EXIF from 'exif-js/exif.js'
import Qs from "qs";
export default {
  name: "editpet",
  data() {
    return {
      showflag: false,
      showflag1: false,
      isshow:true,
      changeflag: false,
      imgflag: false,
      petname: "",
      petbelong: "",
      portrait:"",
      sex: "",
      height: "",
      weight: "",
      birthday: "",
      haircolor: "",
      character: "",
      avatar: "",
      avatar1: "",
      id: "",
      num:"1",
      value: "",
      maxweight:"",
      maxheight:"",
      Height:'',
      options: [
        {
          value: this.$t('prompt.boy'),
          label: this.$t('prompt.boy')
        },
        {
          value: this.$t('prompt.girl'),
          label: this.$t('prompt.girl')
        }
      ],
      flag: false,
      flag1: false,
      flag2: false,
      flag3: false,
      flag4: false,
      flag5: false,
      flag6: false,
      flag7: false,
      flag8: false,
      flag9: false,
      flag10:false,
      flag11:false,
        pickerOptions:{
           disabledDate:(time) =>{
                return time.getTime() > Date.now()
            }
        }
    };
  },
     components: {
    headerTop
  },
  created() {
      this.petname = this.$route.query.petname;
      this.petbelong = this.$route.query.pettype;
      this.value = this.$route.query.sex;
      this.height = this.$route.query.height;
      this.weight = this.$route.query.weight;
      this.birthday = this.$route.query.birthTime.slice(0, 10);
      this.haircolor = this.$route.query.haircolor;
      this.character = this.$route.query.character;
      this.avatar1 = this.$route.query.src;
      this.id = this.$route.query.id;
      this.Height =document.documentElement.clientHeight || document.body.clientHeight;
  },
  beforeUpdate(){
        this.$nextTick(() => {
      this.Scroll = new IScroll(this.$refs.wrapper, {
        click: true
      });
      this.$refs.wrapper.style.height = this.Height-55+'px'
      });
  },
  methods: {
    // 打开图片上传
    uploadHeadImg: function() {
      this.num++
      if(this.num==2){
        this.$el.querySelector(".hiddenInput").click();
      }
    },
    // 将头像显示
    handleFile: function(e) {
      var th = this;
      th.num=1;
      th.imgflag = true;
      let $target = e.target || e.srcElement;
      let file = $target.files[0];
      let maxSize = 400 * 1024;
      var reader = new FileReader();
      let Orientation;
      EXIF.getData(file, function() {
		    Orientation = EXIF.getTag(this, 'Orientation');
        });
      if(file){
      reader.readAsDataURL(file);
      }
      th.changeflag = true;
      reader.onload = data => {
        let res = data.target || data.srcElement;
          if(data.total < maxSize){
          th.showflag1 = false
          th.isshow = true
          th.avatar = res.result;
          th.portrait = data.target.result.split(",")[1]
        }else{
          th.compress(res.result,Orientation)
        }
      };
    },
     compress(result,Orientation){
     var img = new Image();
     var th = this
     img.src = result;
     th.showflag1 = true
     th.isshow = false
    img.onload = function() {
    var width =  img.width;
    var height =  img.height;
    var ratio = 400;
    if (width > ratio) {
          var scaling = 1-(width-ratio)/width;
            width = width * scaling;
            height = height * scaling;
        }
    var canvas = th.$refs.can;
    var ctx = canvas.getContext('2d');
    canvas.width = width;
    canvas.height = height;
    if(Orientation != "" && Orientation != 1&& Orientation != undefined){
        switch(Orientation){
          case 6://需要顺时针（向左）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(90 * Math.PI / 180);
              ctx.drawImage(img, 0, 0,width, -height);
              break;
          case 8://需要逆时针（向右）90度旋转
              canvas.width = height;
              canvas.height = width;
              ctx.rotate(-90 * Math.PI / 180);
              ctx.drawImage(img,0, 0, -width, 0);
              break;
          case 3://需要180度旋转
             ctx.rotate(180 * Math.PI / 180);
             ctx.drawImage(img,0, 0, -width, -height);
             break;
        }
      }else{
         canvas.getContext("2d").drawImage(img, 0, 0, width, height);  
      } 
    var base64 =canvas.toDataURL("image/jpeg", 0.15);         
    th.portrait = base64.split(",")[1]  
    th.avatar = base64.result;           
  };
    },
    //验证宠物名称
    Verificationname() {
      if (this.petname.length == 0) {
        this.flag2 = false;
      }else{
        this.flag6 = false
      }
    },
    //验证宠物品种
    Verificationbelong() {
      if (this.petbelong.length == 0) {
        this.flag3 = false;
      }else{
        this.flag7 = false;
      }
    },
    //验证宠物毛色
    Verificationhaircolor() {
      if (this.haircolor.length == 0) {
        this.flag4 = false;
      }else{
        this.flag8 = false;
      }
    },
    //验证宠物性格
    Verificationcharacter() {
      if (this.character.length == 0) {
        this.flag5 = false;
      }else{
        this.flag11 = false;
      }
    },
    //验证宠物身高
    judgeheight() {
      let reg = /^([1-9][0-9]*)+(.[0-9]{1,2})?$/;
      if (reg.test(this.height)) {
        this.flag = false;
      } else {
        this.flag = true;
      }
      if(this.height.length>0){
        this.flag10 = false;
      }
    },
    //验证宠物体重
    judgeweight() {
      let reg = /^([1-9][0-9]*)+(.[0-9]{1,2})?$/;
      if (reg.test(this.weight)) {
        this.flag1 = false;
      } else {
        this.flag1 = true;
      }
       if(this.weight.length>0){
        this.flag9 = false;
      }
    },
    disapper(){
      this.$refs.datetime.blur()
    },
    back() {
      if (this.changeflag == true || this.value!=this.$route.query.sex || this.birthday!=this.$route.query.birthTime.slice(0, 10)) {
        this.$confirm(this.$t('prompt.cancelchange'), this.$t('prompt.promptcancel'), {
          confirmButtonText: this.$t('prompt.sure'),
          cancelButtonText: this.$t('prompt.cancel'),
          type: "warning"
        })
          .then(() => {
            this.showflag = false;
            this.changeflag = false;
            this.value=this.$route.query.sex
            this.birthday=this.$route.query.birthTime.slice(0, 10)
            this.$emit('react1')
          })
          .catch(() => {});
      } else {
        this.showflag = false;
      }
    },
    save() {
      if(this.petname.length==0){
        this.flag6 = true
      }
       if(this.petbelong.length==0){
        this.flag7 = true
      }
       if(this.haircolor.length==0){
        this.flag8 = true
      }
       if(this.weight.length==0){
        this.flag9 = true
      }
       if(this.height.length==0){
        this.flag10 = true
      }
       if(this.character.length==0){
        this.flag11 = true
      }
      if (
        this.flag == false &&
        this.flag1 == false &&
        this.flag2 == false &&
        this.flag3 == false &&
        this.flag4 == false &&
        this.flag5 == false &&
        this.flag6 == false &&
        this.flag7 == false &&
        this.flag8 == false &&
        this.flag9 == false &&
        this.flag10 == false &&
        this.flag11 == false
      ) {
        setTimeout(()=>{
        var params = Qs.stringify({
          name: this.petname,
          petId: this.id,
          height: this.height,
          weight: this.weight,
          birthTime: this.birthday,
          petType: this.petbelong,
          portrait: this.portrait,
          color: this.haircolor,
          gender: this.value,
          character: this.character
        });
        updatePet(params)
          .then(res => {
            console.log(res);
            if (res.data.header.status == 1000) {
              this.changeflag = false;
              this.showflag = false;
              this.$emit("react",{
                name: res.data.data.name,
                height: res.data.data.height,
                weight: res.data.data.weight,
                pettype: res.data.data.petType,
                haircolor: res.data.data.color,
                sex: res.data.data.gender,
                character: res.data.data.character,
                birthTime: res.data.data.birthTime,
                portrait: res.data.data.portrait
                });
            }
          })
          .catch(error => {
            console.log(error);
          });
        },200)
      }
    },
    show() {
      this.showflag = true;
    },
    changename(e) {
      this.petname = e;
      this.changeflag = true;
    },
    changepetbelong(e) {
      this.petbelong = e;
      this.changeflag = true;
    },
    changeheight(e) {
      this.height = e;
      this.changeflag = true;
      if(this.height.indexOf('.')&&this.height.indexOf('.')==2){
          this.maxheight = 5
      }else if(this.height.indexOf('.')&&this.height.indexOf('.')==1){
        this.maxheight = 4
      }else{
        this.maxheight = 3
      }
    },
    changeweight(e) {
      this.weight = e;
      this.changeflag = true;
      if(this.weight.indexOf('.')&&this.weight.indexOf('.')==2){
          this.maxweight = 5
      }else if(this.weight.indexOf('.')&&this.weight.indexOf('.')==1){
        this.maxweight = 4
      }else{
        this.maxweight = 3
      }
    },
    changebirthday(e) {
      this.birthday = e;
      this.changeflag = true;
    },
    changehaircolor(e) {
      this.haircolor = e;
      this.changeflag = true;
    },
    changecharacter(e) {
      this.character = e;
      this.changeflag = true;
    }
  }
};
</script>
 
<style>
.el-message-box {
  width: 300px;
}
.editpet .el-input__inner {
  color: rgb(9, 81, 150);
}
.editpet .el-button--primary{
background-color: rgb(9,81,150);
border-color: rgb(9,81,150);
}
.el-message {
  min-width: 50%;
}
.editpet .el-input--prefix .el-input__inner {
  padding-left: 22px;
}
.editpet .el-input__prefix {
  left: 0;
}
@media screen and (min-width: 320px) and (max-width: 568px) {
  .editpet .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 125px;
  }
}
@media screen and (min-width: 375px) and (max-width: 667px) {
  .editpet .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 152.5px;
  }
}
@media screen and (min-width: 414px) and (max-width: 736px) {
  .editpet .el-date-editor.el-input,
  .el-date-editor.el-input__inner {
    width: 172px;
  }
}
</style>
<style scoped>
@media screen and (max-width: 321px) {
    .petmessage span{
        font-size: 0.78rem !important;
    }
}
.btn {
  color: #fff;
  background-color: #034694;
  width: 80%;
  margin: 0 auto;
  border: 0;
  height: 40px;
  display: block;
  margin-bottom: 20px;
}
.editpet .danger {
  font-size: 0.625rem;
  color: red;
  margin-top:5px;
}
.head_img{
  margin-top: 15px;
}
.head_img img {
  width: 80px;
  height: 80px;
  border-radius: 50px;
}
.hiddenInput {
  display: none;
}
.editpet {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0px;
  width: 100%;
  z-index: 30;
  background-color: #fff;
  transition: all 0.2s linear;
}
.editpet.show-enter,
.editpet.show-leave-to {
  transform: translateX(100%);
}

.back {
  width: 22px;
  height: 22px;
  position: absolute;
  top: 18%;
}
.main {
  position: absolute;
  top: 55px;
  bottom: 0px;
  width: 100%;
  overflow: hidden;
  touch-action: none;
}
.title p {
  text-align: center;
  font-size: 0.875rem;
  padding-top: 5px;
}

.petname {
  flex: 1;
  margin-left: 15px;
  margin-top: 30px;
}
.petmessage span {
  font-size: 0.8rem;
  margin-bottom: 5px;
  margin-left: 3px;
  display: block;
}
.petmessage p {
  font-size: 0.875rem;
}
.petbelong {
  flex: 1;
  margin-top: 30px;
  margin-right: 15px;
  margin-left: 40px;
}
.pet-msg {
  display: flex;
}
.sex {
  flex: 1;
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 40px;
}
.height {
  flex: 1;
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 40px;
}
.weight {
  flex: 1;
  margin-left: 15px;
  margin-top: 20px;
}
.birthday {
  flex: 1;
  margin-left: 15px;
  margin-top: 20px;
}
.haircolor {
  flex: 1;
  margin-left: 15px;
  margin-top: 20px;
}
.character {
  flex: 1;
  margin-top: 20px;
  margin-right: 15px;
  margin-left: 40px;
}
</style>



// WEBPACK FOOTER //
// src/m_page/myAccount/editpet.vue